import { render, staticRenderFns } from "./AppStatusBadge.vue?vue&type=template&id=4622e337&scoped=true&"
import script from "./AppStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AppStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./AppStatusBadge.vue?vue&type=style&index=0&id=4622e337&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622e337",
  null
  
)

export default component.exports